<script lang="ts" setup>
import { useRecipientLanding } from '@consumer/modules/recipientGiftLandingV2/composables'

const { secondaryBgColor, secondaryTextColor } = useRecipientLanding()
</script>
<template>
  <div class="hero-header absolute top-0 w-full text-base font-semibold bg-white rounded-none lg:rounded-t-v2lg">
    <div
      class="p-4 w-full flex justify-center items-center rounded-none lg:rounded-t-v2lg h-full"
      :style="{
        backgroundColor: secondaryBgColor,
        color: secondaryTextColor,
      }"
    >
      <slot/>
    </div>
  </div>
</template>
